import React from 'react';

export const ArrowSingle = ({ width = '30', height = '30' }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 30 31"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.375 6.75L10.625 15.5L19.375 24.25"
        stroke="#0A3A86"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
